import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { MissJonesIndexCardStackContentViewModel } from './miss-jones-index-card-stack-content-view-model';

@Component({
  selector: 'app-miss-jones-index-card-stack-content',
  templateUrl: './miss-jones-index-card-stack-content.component.html',
  styleUrls: ['./miss-jones-index-card-stack-content.component.scss'],
  providers: [MissJonesIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MissJonesIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: MissJonesIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
